import React, { useEffect, useState } from "react";
import Cards from "../../cards/Cards";
import PerformaceVendas from "../../cards/PerformaceVendas";
import ValorCard from "../../cards/ValorCard";
import Sidebar from "../../menu/Sidebar";
import Topbar from "../../menu/Topbar";
import Api from "../../Services/Api";
import ExtratoFilters from "../tabelaExtrato/ExtratoFilter";
import TabelaExtrato from "../tabelaExtrato/TabelaExtrato";
import "../historico/Historico.css";

const INITIAL_FILTERS = {
  type: "ALL",
  status: "ALL",
  order: "",
  start: "",
  end: "",
};

const LIMIT = 20;

function buildParams(filters, offset) {
  const p = {
    type: filters.type,
    status: filters.status,
    order: filters.order?.trim(),
    start: filters.start,
    end: filters.end,
    limit: LIMIT,
    offset,
  };

  Object.keys(p).forEach((k) => {
    if (!p[k] || p[k] === "ALL") delete p[k];
  });

  return p;
}

const ExtratoCompleto = () => {
  const [menuClose, setMenuClose] = useState(false);
  const toggleMenu = () => setMenuClose((prev) => !prev);

  const [extratoDados, setExtratoDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [offset, setOffset] = useState(0);
  const [pagination, setPagination] = useState({
    total: 0,
    limit: LIMIT,
    offset: 0,
    hasMore: false,
  });

  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const fetchData = async ({ targetOffset = offset, targetFilters = filters } = {}) => {
    try {
      setLoading(true);

      const response = await Api.get("/ledger-entries/me/history", {
        params: buildParams(targetFilters, targetOffset),
      });
      const payload = response.data?.data ?? response.data ?? [];
      const list = Array.isArray(payload) ? payload : [];

      const paginationData = response.data?.pagination;
      const apiTotal = Number(paginationData?.total);
      const loadedThrough = targetOffset + list.length;
      const hasUsableTotal = Number.isFinite(apiTotal) && apiTotal >= loadedThrough;
      const total = hasUsableTotal
        ? apiTotal
        : loadedThrough + (list.length === LIMIT ? 1 : 0);
      const more = hasUsableTotal
        ? typeof paginationData?.hasMore === "boolean"
          ? paginationData.hasMore
          : loadedThrough < total
        : list.length === LIMIT;

      setPagination({
        total,
        limit: Number(paginationData?.limit ?? LIMIT),
        offset: Number(paginationData?.offset ?? targetOffset),
        hasMore: more,
      });
      setExtratoDados(list);
    } catch (err) {
      console.error("Erro ao carregar extrato completo:", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchData({ targetOffset: offset });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [offset]);

  const handleApplyFilters = () => {
    setOffset(0);
    if (offset === 0) fetchData({ targetOffset: 0 });
  };

  const handleClearFilters = () => {
    setFilters(INITIAL_FILTERS);
    setOffset(0);
    if (offset === 0) fetchData({ targetOffset: 0, targetFilters: INITIAL_FILTERS });
  };

  const currentPage = Math.floor(offset / LIMIT) + 1;
  const totalPages = Math.max(1, Math.ceil((pagination.total || 0) / LIMIT));
  const startItem = pagination.total === 0 ? 0 : (currentPage - 1) * LIMIT + 1;
  const endItem = Math.min(currentPage * LIMIT, pagination.total || extratoDados.length);
  const canGoNext = pagination.hasMore || currentPage < totalPages;

  const handleNextPage = () => {
    if (loading || !canGoNext) return;
    setOffset((prev) => prev + LIMIT);
  };

  const handlePreviousPage = () => {
    if (loading || offset === 0) return;
    setOffset((prev) => Math.max(0, prev - LIMIT));
  };

  return (
    <div className="app-container">
      <Sidebar close={menuClose} extratoActive="active" />

      <main className="main-content">
        <Topbar page="Extrato" onToggleMenu={toggleMenu} />

        <Cards>
          <ValorCard />
          <PerformaceVendas />
        </Cards>

        <ExtratoFilters
          filters={filters}
          loading={loading}
          onChange={(partial) => setFilters((prev) => ({ ...prev, ...partial }))}
          onApply={handleApplyFilters}
          onClear={handleClearFilters}
        />

        <TabelaExtrato
          itensLista={extratoDados}
          loading={loading}
          pagination={{
            currentPage,
            totalPages,
            totalItems: pagination.total,
            pageSize: pagination.limit || LIMIT,
            startItem,
            endItem,
            hasPrevious: currentPage > 1,
            hasNext: canGoNext,
            onPrevious: handlePreviousPage,
            onNext: handleNextPage,
          }}
        >
          <div>Extrato completo (todo o historico de lancamentos).</div>
        </TabelaExtrato>
      </main>
    </div>
  );
};

export default ExtratoCompleto;
